module.exports = __webpack_public_path__ + "static/media/information-line.0f73e76f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/information-line.svg
// module id = 868
// module chunks = 3